// extracted by mini-css-extract-plugin
module.exports = {"label":"EmailForm_label__6pmHG","submit":"EmailForm_submit__1iu6t","touched":"EmailForm_touched__1NlSt","error":"EmailForm_error__YfENA"};